import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@/../environments/environment';

export interface PagadorTesteCreateRequest {
  nome: string;
  cpf: string;
  nomeCompleto: string;
  logradouro: string;
  numero: string;
  cep: string;
  bairro: string;
  cidade: string;
  uf: string;
}

export interface PagadorTesteUpdateRequest {
  nome?: string;
  cpf?: string;
  nomeCompleto?: string;
  logradouro?: string;
  numero?: string;
  cep?: string;
  bairro?: string;
  cidade?: string;
  uf?: string;
  ativo?: boolean;
}

export interface PagadorTesteResponse {
  id: number;
  nome: string;
  cpf: string;
  nomeCompleto: string;
  logradouro: string;
  numero: string;
  cep: string;
  bairro: string;
  cidade: string;
  uf: string;
  ativo: boolean;
  createdAt: string;
  updatedAt: string;
}

@Injectable({
  providedIn: 'root',
})
export class PagadoresTesteService {
  private baseUrl = `${environment.apiUrl}/admin/pagadores-teste`;

  constructor(private http: HttpClient) {}

  criar(request: PagadorTesteCreateRequest): Observable<PagadorTesteResponse> {
    return this.http.post<PagadorTesteResponse>(this.baseUrl, request);
  }

  atualizar(id: number, request: PagadorTesteUpdateRequest): Observable<PagadorTesteResponse> {
    return this.http.put<PagadorTesteResponse>(`${this.baseUrl}/${id}`, request);
  }

  remover(id: number): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/${id}`);
  }

  buscarPorId(id: number): Observable<PagadorTesteResponse> {
    return this.http.get<PagadorTesteResponse>(`${this.baseUrl}/${id}`);
  }

  listarAtivos(): Observable<PagadorTesteResponse[]> {
    return this.http.get<PagadorTesteResponse[]>(this.baseUrl);
  }

  listarTodos(): Observable<PagadorTesteResponse[]> {
    return this.http.get<PagadorTesteResponse[]>(`${this.baseUrl}/todos`);
  }
}
